import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "SearchHeader" }
const _hoisted_2 = { class: "SearchHeading" }
const _hoisted_3 = { class: "NavigationButtons" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchTabs, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          type: "button",
          class: _normalizeClass(["SearchNavigationButton", { Active: tab.type === _ctx.searchTypeStudy }]),
          key: tab.type,
          onClick: ($event: any) => (_ctx.switchToTab(tab.type))
        }, _toDisplayString(tab.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}